<template>
  <div class="view-wrap" :class="width">
    <div class="view">
      <section>
        <div class="section-inner">
          <slot></slot>
        </div>
      </section>
      <div class="full">
        <slot name="full"></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'view-wrap',
  props: ['width'],
  data () {
    return {}
  },
  created: function () {},
  computed: {},
  methods: {}
}
</script>
<style src="./view-wrap.styl" lang="stylus"></style>
